module.exports = __webpack_public_path__ + "img/银行卡识别.f9ae8587.png";